import React from 'react';
import { translate } from '@utils/i18n';
import { NAMESPACE } from '../constants';
export function IntervalCell({ item }) {
    return (React.createElement("span", { className: "sprinkler-projection__cell-nowrap" },
        item.interval,
        item.retestInterval && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement("span", { className: "sprinkler-projection__cell-annotation" }, translate('retest_interval', { namespace: NAMESPACE, count: item.retestInterval }))))));
}
